import { useNewTranslations } from '@/common/translations';

import stadiumBg from '../../assets/stadium.png';

interface StadiumInformationProps {
  /** Name of the stadium. */
  name: string;
  /** Stadium capacity (number of seats). */
  capacity?: number | null;
}

export default function StadiumInformation({ name, capacity }: StadiumInformationProps) {
  const translate = useNewTranslations();

  const formattedCapacity = capacity
    ? // Format capacity with spaces as thousand separators, e.g. 30 576
      capacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    : '';

  return (
    <div
      className="flex justify-center items-center h-[72px] w-full p-[8px] rounded-[12px] bg-[lightgray] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${stadiumBg})` }}
    >
      <div className="relative flex flex-col justify-center items-center py-[8px] px-[16px] rounded-[12px] overflow-hidden">
        <div className="absolute w-full h-full rounded-[12px] bg-pmw-stadium-info-bg blur-[1px]" />
        <span className="max-w-full truncate text-center font-robotoMedium font-medium text-[12px] leading-[16px] text-pmw-label-primary-light z-1">
          {name}
        </span>
        {formattedCapacity && (
          <span className="lowercase font-robotoMedium font-medium text-[10px] leading-[16px] text-pmw-label-secondary-light z-1">
            {formattedCapacity} {translate('PreMatchStats.Seats')}
          </span>
        )}
      </div>
    </div>
  );
}
